// Loader.js
import { Typography } from "@mui/material";
import { STORAGE_URL } from "../constants";
import "./Loader.css";

const Loader = ({ home, landScape = false }) => {
  return (
    <div
      className="loader-slide"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginInline: "auto",
        backgroundSize: "cover",
        objectFit: "cover",
        zIndex: 10000,
        backgroundRepeat: "no-repeat",
        backgroundColor: "#000",
      }}
    >
      {home && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={STORAGE_URL + "yuga/peephole.gif"}
            loop
            className="video-size"
          />

          <img
            className="img-style"
            style={{}}
            src={STORAGE_URL + "yuga/peephole-window.webp"}
          />
        </div>
      )}
      {landScape && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "30px",
          }}
        >
          <img
            style={{ height: "20px", width: "20px" }}
            src={STORAGE_URL + "yuga/mobileLandscape.svg"}
          />
          <Typography
            sx={{
              fontWeight: "600",
              fontFamily: "var(--font-g)",
              textTransform: "capitalize",
              color: "#2E2D2D",
              textAlign: "center",

              fontSize: "20px",
            }}
          >
            Please rotate your screen
          </Typography>
        </div>
      )}
    </div>
  );
};

export default Loader;
